import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import PageManager from "../../components/pageManager/PageManager";

const PageManagerPage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <PageManager />
                </div>
            </div>
        </div>
    );
};

export default PageManagerPage;
